import * as React from "react";
import type { SVGProps } from "react";
const SvgStarnoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="starno_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 42.667a42.667 42.667 0 0 1 38.272 23.765l121.899 247.04 272.64 39.85a42.667 42.667 0 0 1 23.637 72.747L771.2 618.197l46.507 271.446a42.667 42.667 0 0 1-61.867 44.97L512 806.4 268.16 934.613a42.667 42.667 0 0 1-61.867-44.97L252.8 618.197 55.552 426.07a42.667 42.667 0 0 1 23.595-72.746l272.64-39.894L473.728 66.432A42.667 42.667 0 0 1 512 42.667zm0 139.093-93.568 189.525a42.667 42.667 0 0 1-32.085 23.296L176.98 425.216l151.467 147.499a42.667 42.667 0 0 1 12.288 37.76L304.98 818.816l187.179-98.432a42.667 42.667 0 0 1 39.68 0l187.179 98.432-35.755-208.341a42.667 42.667 0 0 1 12.288-37.76l151.467-147.499-209.366-30.635a42.667 42.667 0 0 1-32.085-23.296L512 181.717z"
    />
  </svg>
);
export default SvgStarnoIcon;
